import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import FeatureCarousel from "../components/FeatureCarousel/FeatureCarousel"
import { StoriesTeaserAndCTA } from "../components/StoriesTeaserAndCTA"
import { ThreeTeaserComponent } from "../components/Teaser"
import WhyModule from "../components/WhyModule/WhyModule"
import { Graph } from "../components/Graph"
import { SubsitePageWrapper } from "components/ProjectStyles"
import { DividerLines } from "components/DividerLines"

const SubsitePage = () => {
  return (
    <Layout
      subsite
      site="business"
      headerTitle="A globally connected city"
      headerText="There’s no better place to do business. This is where key decision makers meet, negotiations take place and brilliant possibilities come to life."
    >
      <SEO title="Subsite" />
      <SubsitePageWrapper>
        <WhyModule />
        <FeatureCarousel />
        <DividerLines />

        <ThreeTeaserComponent
          mainTitle="Grow your business in Canberra"
          data={[
            {
              title: "Lifestyle",
              excerpt:
                "The ultimate work/life balance with access to world-class facilities, stunning natural surrounds and great career opportunities.",
              link: "/",
              label: "Find out more",
            },
            {
              title: "Housing & Cost of Living",
              excerpt:
                "A home is the foundation for your life in Canberra. Learn more about the areas you want to live in and options to suit you and your family.",
              link: "/",
              label: "Find out more",
            },
            {
              title: "Business in Canberra",
              excerpt:
                "There’s no better place to do business. This is where key decision makers meet, negotiations take place and brilliant possibilities come to life.",
              link: "/",
              label: "Find out more",
            },
          ]}
        />
        <Graph />
        <StoriesTeaserAndCTA />
      </SubsitePageWrapper>
    </Layout>
  )
}

export default SubsitePage
